enum ConsentCodeEnum
{
    FINANCIAL_DISPO = 'FINANCIAL_DISPO',
}

export default ConsentCodeEnum;
